import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AdminComponent} from './layouts/admin/admin.component';
import {AuthComponent} from './layouts/auth/auth.component';
import {AuthGuard} from './layouts/auth/guards/auth.guard';
import {AuthService} from './layouts/auth/guards/auth.service';

{ initialNavigation: false }
const routes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: '/auth/login',
        pathMatch: 'full'
      },
      {
        path: 'sponsorregistration',
        loadChildren: () => import('./inv_reg/dashboard.module')
        .then(m => m.DashboardModule), canActivate: [AuthGuard]
      },
      {
        path: 'sponsorcontact',
        loadChildren: () => import('./inv_contact/dashboard_contact.module')
        .then(m => m.DashboardContactModule), canActivate: [AuthGuard]
      },
      {
        path: 'sponsoruploadfiles',
        loadChildren: () => import('./inv_uploadfiles/inv_uploadfiles.module')
        .then(m => m.INVUploadfilesModule), canActivate: [AuthGuard]
      },
      {
        path: 'sponsordashboard',
        loadChildren: () => import('./sponsor/invdashboard/invdashboard.module')
        .then(m => m.INVDashboardModule), canActivate: [AuthGuard]
      },
      {
        path: 'marketplace',
        loadChildren: () => import('./sponsor/marketplace/marketplace.module')
        .then(m => m.MarketPlaceModule), canActivate: [AuthGuard]
      },
      {
        path: 'projectdetails/:code',
        loadChildren: () => import('./sponsor/projectdetails/projectdetails.module')
        .then(m => m.ProjectDetailsModule), canActivate: [AuthGuard]
      },
      {
        path: 'smeregistation',
        loadChildren: () => import('./smi_reg/smi_reg.module')
        .then(m => m.SMIRegModule), canActivate: [AuthGuard]
      },
      {
        path: 'smecontact',
        loadChildren: () => import('./smi_contact/smi_contact.module')
        .then(m => m.SMIContactModule), canActivate: [AuthGuard]
      },
      {
        path: 'smeuploadfiles',
        loadChildren: () => import('./smi_uploadfiles/dashboard_uploadfiles.module')
        .then(m => m.DashboardUploadfilesModule), canActivate: [AuthGuard]
      },
      {
        path: 'smedashboard',
        loadChildren: () => import('./sme/smedashboard/smedashboard.module')
        .then(m => m.SMEDashboardModule), canActivate: [AuthGuard]
      },
      {
        path: 'mysmeprojects',
        loadChildren: () => import('./sme/mysmeprojects/mysmeprojects.module')
        .then(m => m.SMEProjectsModule), canActivate: [AuthGuard]
      },
      {
        path: 'viewsmeprojects/:id',
        loadChildren: () => import('./sme/viewprojectdetails/viewprojectdetails.module')
        .then(m => m.ViewSMEProjectsModule), canActivate: [AuthGuard]
      },
      {
        path: 'sponsor/viewprofile',
        loadChildren: () => import('./user/viewprofile/viewprofile.module')
        .then(m => m.ViewProfileModule), canActivate: [AuthGuard]
      },
      {
        path: 'sponsor/editprofile',
        loadChildren: () => import('./user/editprofile/editprofile.module')
        .then(m => m.EditProfileModule), canActivate: [AuthGuard]
      },
      {
        path: 'sme/viewprofile',
        loadChildren: () => import('./user/smeviewprofile/smeviewprofile.module')
        .then(m => m.SMEViewProfileModule), canActivate: [AuthGuard]
      },
      {
        path: 'sme/editprofile',
        loadChildren: () => import('./user/smeeditprofile/smeeditprofile.module')
        .then(m => m.SMEEditProfileModule), canActivate: [AuthGuard]
      },
      {
        path: 'sme/settings',
        loadChildren: () => import('./user/smeaccountsettings/smeaccountsettings.module')
        .then(m => m.SMEAccountSettingsModule), canActivate: [AuthGuard]
      },
      {
        path: 'sponsor/settings',
        loadChildren: () => import('./user/accountsettings/accountsettings.module')
        .then(m => m.AccountSettingsModule), canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./layouts/auth/auth.module')
        .then(m => m.AuthModule)
      },
    ]
  },
  {
    path: '**',
    redirectTo: '/auth/login'
  }
];

@NgModule({
  // imports: [RouterModule.forRoot(routes, {
  //   onSameUrlNavigation: 'reload'
  // })],
  imports: [RouterModule.forRoot(routes, { initialNavigation: true })],
  // imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard, AuthService]
})
export class AppRoutingModule { }
